import Proveidor from "../../model/menudesign/Proveidor";

const apiUrl = process.env.REACT_APP_API_URL;
export const PostProveidors = async (page: string, proveidor: Proveidor, id_usuLog: string) => {
    try {
        const response = await fetch(`${apiUrl}:8072/proveidors/${id_usuLog}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(proveidor)
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};